import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#114A4E",
      d: "M11 18q2.9 0 4.95-2.042T18 11q0-2.9-2.05-4.95T11 4Q8.085 4 6.042 6.05 4 8.1 4 11q0 2.915 2.042 4.958Q8.084 18 11 18m0 1.5a8.3 8.3 0 0 1-3.315-.67 8.6 8.6 0 0 1-2.697-1.818 8.6 8.6 0 0 1-1.819-2.697A8.3 8.3 0 0 1 2.5 11q0-1.755.67-3.3a8.542 8.542 0 0 1 4.515-4.53A8.3 8.3 0 0 1 11 2.5q1.755 0 3.3.67a8.6 8.6 0 0 1 2.704 1.826A8.6 8.6 0 0 1 18.83 7.7q.669 1.545.669 3.3a8.2 8.2 0 0 1-.53 2.948 8.9 8.9 0 0 1-1.464 2.514l3.477 3.477a.67.67 0 0 1 .21.517.758.758 0 0 1-1.28.517l-3.467-3.452a8.7 8.7 0 0 1-2.513 1.457A8.3 8.3 0 0 1 11 19.5"
    }, null, -1)
  ])))
}
export default { render: render }